/* unplugin-vue-components disabled */import script from "./PriceBlock1.vue?vue&type=script&lang=ts&setup=true"
export * from "./PriceBlock1.vue?vue&type=script&lang=ts&setup=true"

import "./PriceBlock1.vue?vue&type=style&index=0&id=fa961fc6&lang=less&scoped=true"

import exportComponent from "/data/jenkins/workspace/infra_PayAdminWeb/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fa961fc6"]])

export default __exports__